
<div class="card offcanvas-card m-0 bg-transparent">
  <div class="card-body">
    <div class="row d-flex justify-content-between align-items-center mb-3">
      <div class="col-8 d-flex align-items-center">
        <h6 class="m-0 offcanvas-header-text d-flex align-items-center">
          Disable Tab Swiping
          <i
            class="mdi mdi-information-outline font-size-16 ms-1"
            tooltip="Turn off horizontal swipe gestures between tabs, allowing navigation only through tab selection."
          ></i>
        </h6>
      </div>
      <div class="col-4 justify-content-end">
        <ui-switch
          color="#34c38f"
          [checked]="appHome.app.tabs && appHome.app.tabs.tab_swipe_off ? true : false"
          uncheckedLabel="No"
          checkedLabel="Yes"
          size="small"
          class="me-1"
          (change)="toggle($event)"
        ></ui-switch>
      </div>
    </div>

  </div>
</div>

